import { useEffect } from "react"
import { useAppDispatch } from "@/store/hooks"
import { updateUtms, type UTMs } from "@/store/slices/urlSlice"

const UTM_STORAGE_KEY = "biosany.utms"

function readStoredUtms(): UTMs | null {
	try {
		const raw = sessionStorage.getItem(UTM_STORAGE_KEY)
		if (!raw) return null
		return JSON.parse(raw) as UTMs
	} catch {
		return null
	}
}

function writeStoredUtms(utms: UTMs): void {
	sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utms))
}

function hasAnyUtm(utms: UTMs): boolean {
	return Boolean(utms.utm_source || utms.utm_medium || utms.utm_campaign || utms.utm_term || utms.utm_content)
}

/**
 * Captura UTMs de la URL una vez por sesión y los guarda en Redux + sessionStorage
 * para el checkout.
 */
export default function UtmCapture(): null {
	const dispatch = useAppDispatch()

	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		const fromUrl: UTMs = {
			utm_source: params.get("utm_source"),
			utm_medium: params.get("utm_medium"),
			utm_campaign: params.get("utm_campaign"),
			utm_term: params.get("utm_term"),
			utm_content: params.get("utm_content")
		}

		if (hasAnyUtm(fromUrl)) {
			dispatch(updateUtms(fromUrl))
			writeStoredUtms(fromUrl)
			return
		}

		const stored = readStoredUtms()
		if (stored && hasAnyUtm(stored)) {
			dispatch(updateUtms(stored))
		}
	}, [dispatch])

	return null
}
